export const KUNDLISTAR_CHART_HEADER = ['ID', 'FullName', 'Gender', 'BirthDate', 'BirthTime', 'City', 'State', 'Country', 'Latitude', 'Longitude', 'OffsetMinutes', 'ChartType'];

export interface KundlistarChartRow {
  id: string;
  name: string;
  gender: 'Male' | 'Female' | 'Other';
  date: string;
  time: string;
  city: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  offsetMinutes: number;
}

export function parseKundlistarChartFile(text: string): { rows: KundlistarChartRow[]; errors: string[] } {
  const lines = text.replace(/^\uFEFF/, '').split(/\r?\n/).filter(line => line.trim());
  const errors: string[] = [];
  if (lines[0]?.split('\t').join('\t') !== KUNDLISTAR_CHART_HEADER.join('\t')) {
    return { rows: [], errors: ['This is not a Kundlistar chart export file. Select the original .txt file from Export all charts.'] };
  }
  if (lines.length > 501) return { rows: [], errors: ['Import up to 500 charts at a time.'] };
  const rows: KundlistarChartRow[] = [];
  const seen = new Set<string>();
  lines.slice(1).forEach((line, index) => {
    const cells = line.replace(/\r$/, '').split('\t');
    const lineNumber = index + 2;
    if (cells.length !== KUNDLISTAR_CHART_HEADER.length) { errors.push(`Line ${lineNumber}: incorrect number of columns.`); return; }
    const [id, name, gender, date, time, city, state, country, lat, lng, offset, chartType] = cells.map(value => value.trim());
    if (chartType !== 'birth') { errors.push(`Line ${lineNumber}: only birth charts can be imported.`); return; }
    const [year, month, day] = date.split('-').map(Number);
    const calendarDate = new Date(0);
    calendarDate.setUTCFullYear(year, month - 1, day);
    calendarDate.setUTCHours(0, 0, 0, 0);
    const validDate = /^\d{4}-\d{2}-\d{2}$/.test(date) && year >= 1 && calendarDate.getUTCFullYear() === year && calendarDate.getUTCMonth() === month - 1 && calendarDate.getUTCDate() === day;
    const timeMatch = /^(\d{2}):(\d{2}):(\d{2})$/.exec(time);
    const latitude = Number(lat), longitude = Number(lng), offsetMinutes = Number(offset);
    if (!id || !name || name.length > 100 || !['Male', 'Female', 'Other'].includes(gender) || !validDate || !timeMatch || Number(timeMatch[1]) > 23 || Number(timeMatch[2]) > 59 || Number(timeMatch[3]) > 59 || !city || !country || !lat || !lng || !offset || !Number.isFinite(latitude) || Math.abs(latitude) > 90 || !Number.isFinite(longitude) || Math.abs(longitude) > 180 || !Number.isInteger(offsetMinutes) || Math.abs(offsetMinutes) > 720) {
      errors.push(`Line ${lineNumber}: invalid birth details or location.`); return;
    }
    const key = [name.toLowerCase(), gender, date, time, latitude, longitude].join('|');
    if (seen.has(key)) return;
    seen.add(key);
    rows.push({ id, name, gender: gender as KundlistarChartRow['gender'], date, time, city, state, country, latitude, longitude, offsetMinutes });
  });
  if (!rows.length && !errors.length) errors.push('The file contains no charts.');
  return { rows, errors };
}
